import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qualifiedlead',
  templateUrl: './qualifiedlead.component.html',
  styleUrls: ['./qualifiedlead.component.css']
})
export class QualifiedleadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
